import { ReactElement, useContext } from 'react'
import styles from './ProductPaymentModal.module.scss'
import { FaTimesIcon } from '../../../../Assets/ReactIcons'
import { SectionSeparator } from '../../sectionSeparator/sectionSeparator'
import { ButtonByAdam } from '../../buttons/ButtonByAdam/ButtonByAdam'
import { CheckoutProductPrzelewy24 } from '../../../../service/Stripe/checkout'
import { GlobalLoaderContext } from '../../../../Context/GlobalLoader/GlobalLoader'
import { GlobalNotificationContext } from '../../../../Context/GlobalNotification/GlobalNotificationProvider'
import { PLEASE_WAIT } from '../../../../const/consts'
import { NotificationType } from '../../../../Context/GlobalNotification/Types'

export interface ModalProductProps {
  productID: string
  userEmail: string
}

export interface ModalPaymentProps {
  isModalVisible: boolean
  product: ModalProductProps | null
}

interface Props {
  children?: ReactElement
  headerLabel?: string
  headerColor?: 'warning' | 'positive' | 'information' | 'normal'
  confirmBtnText?: string
  declineBtnText?: string
  paymentData: ModalPaymentProps
  onModalClose: () => void
}

export const ProductPaymentModal = ({
  children,
  headerLabel,
  headerColor,
  confirmBtnText,
  declineBtnText,
  paymentData,
  onModalClose
}: Props): JSX.Element => {
  const showLoader = useContext(GlobalLoaderContext)
  const showNotification = useContext(GlobalNotificationContext)

  const paymentHandler = async () => {
    if (!paymentData.product) {
      showNotification(NotificationType.ERROR, 'Nie wybrano kursu do zakupu.')
      return
    }

    showLoader(true, PLEASE_WAIT)

    try {
      await CheckoutProductPrzelewy24({
        productId: paymentData.product.productID,
        email: paymentData.product.userEmail
      })
      onModalClose()
    } catch {
      showNotification(
        NotificationType.ERROR,
        'Płatność się nie powiodła. Spróbuj jeszcze raz lub skontaktuj się z administratorem.'
      )
    } finally {
      showLoader(false)
    }
  }

  return (
    <div className={styles.ModalMask}>
      <div>
        <div
          className={`${styles.HeaderContainer} ${
            styles[headerColor || 'positive']
          }`}
        >
          <h2>{headerLabel || 'Przeczytaj'}</h2>
          <div
            aria-hidden='true'
            tabIndex={0}
            role='button'
            onClick={onModalClose}
          >
            {FaTimesIcon}
          </div>
        </div>

        <div className={styles.ModalWrapper}>
          <div className={styles.ContentContainer}>
            <p>
              {children ||
                'Za moment zostaniesz przekierowany do strony, na której będzie można dokonać płatności za kurs. Po zaakceptowaniu płatności powinieneś mieć dostęp do wybranego materiału w ciągu 5 minut. Jeżeli napotkasz problemy, służymy pomocą!'}
            </p>
          </div>

          <SectionSeparator width={100} marginTop={30} marginBottom={10} />

          <div className={styles.InputsContainer}>
            <ButtonByAdam btnType='green' onClick={paymentHandler}>
              {confirmBtnText || 'Zatwierdź'}
            </ButtonByAdam>
            <ButtonByAdam btnType='red' onClick={onModalClose}>
              {declineBtnText || 'Wróć'}
            </ButtonByAdam>
          </div>
        </div>
      </div>
    </div>
  )
}
